

function NoPage() {
    return (
        <>                        
            <br/>
            <br/>
            <h2>Die von Ihnen eingegebene Seite konnte leider nicht gefunden werden.</h2>
            <br/>
            <br/>
        </>
    )
}

export default NoPage;